/**
 * The Config tab's input from the editor's draft and the live ranking — the
 * reuse pool (best-first) and this container's prompt groups.
 * For Media Devoted | Created By Ciro Autiero
 */
import { type DropGenRankedGroup, type DropGenRankedText, type DropGenTextMixInput } from '@trafficpulse/shared';

export interface FillExampleInput extends DropGenTextMixInput {
  leanGroups: boolean;
  textMode: string;
  /** The reuse pool, best-first. */
  pool: DropGenRankedText[];
  /** This container's prompt groups as the ranking sees them (unranked ones included). */
  groups: Array<Pick<DropGenRankedGroup, 'groupId' | 'groupName' | 'rank' | 'score'>>;
}

/** The example's input from the editor's draft and the live ranking. */
export function fillExampleInput(
  ranking: Pick<DropGenTextMixInput, 'provenPerDrop' | 'policy'> & { leanGroups: boolean },
  creative: { textMode: string; amount: number; textGroupIds: string[] },
  ranked: { texts: DropGenRankedText[]; groups: DropGenRankedGroup[] },
): FillExampleInput {
  const byId = new Map(ranked.groups.map((g) => [g.groupId, g]));
  return {
    provenPerDrop: ranking.provenPerDrop,
    policy: ranking.policy,
    amount: creative.amount,
    leanGroups: ranking.leanGroups,
    textMode: creative.textMode,
    pool: ranked.texts.filter((t) => t.inPool),
    groups: creative.textGroupIds.flatMap((id) => byId.get(id) ?? []),
  };
}
